(function () {
  'use strict';
  var configNode = document.getElementById('kopero-market-defaults');
  if (!configNode) return;
  function ready() {
    document.documentElement.dataset.keMarketReady = 'true';
    document.dispatchEvent(new Event('kopero:market-ready'));
  }
  var config = JSON.parse(configNode.textContent);
  var host = location.hostname.replace(/^www\./, '');
  var german = host === 'kopero.de';
  var fallback = german ? 'AT' : 'BG';
  var preferred = german ? 'DE' : 'IE';
  var form = document.querySelector('.kopero-market-form');
  if (!form) return;
  var select = form.elements.country_code;
  var ownDomains = ['NL', 'BE', 'DE', 'AT', 'FR', 'ES', 'PT', 'DK', 'SE'];
  function valid(country) {
    if (!country || !Array.prototype.some.call(select.options, function (option) { return option.value === country; })) return false;
    return german ? country === 'DE' || country === 'AT' : ownDomains.indexOf(country) === -1;
  }
  function remember(country) {
    try { localStorage.setItem('kopero-delivery-country', country); } catch (error) {}
  }
  var params = new URLSearchParams(location.search);
  var explicit = params.get('country');
  if (valid(explicit)) { remember(explicit); ready(); return; }
  // A non-fallback native selection, such as Poland on .eu, is authoritative.
  if (config.country !== fallback) { remember(config.country); ready(); return; }
  var saved;
  try { saved = localStorage.getItem('kopero-delivery-country'); } catch (error) {}
  var cancelled = false;
  document.addEventListener('change', function (event) {
    if (event.target.matches('.kopero-market-form [name="country_code"]')) cancelled = true;
  });
  async function start() {
    var target = valid(saved) ? saved : preferred;
    if (!valid(saved)) {
      try {
        var controller = new AbortController();
        var timer = setTimeout(function () { controller.abort(); }, 2000);
        var response = await fetch((window.Shopify.routes.root || '/') + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', { signal: controller.signal });
        clearTimeout(timer);
        if (response.ok) {
          var data = await response.json();
          var detected = data.detected_values && data.detected_values.country && data.detected_values.country.handle;
          if (valid(detected)) target = detected;
        }
      } catch (error) { /* A blocked recommendation request must not block shopping. */ }
    }
    if (cancelled || form.dataset.busy || !valid(target)) return;
    if (target === config.country) { remember(target); ready(); return; }
    // Never reload repeatedly if a browser refuses Shopify's country cookie.
    var attempt = host + ':' + target;
    try {
      if (sessionStorage.getItem('kopero-country-default-attempt') === attempt) return;
      sessionStorage.setItem('kopero-country-default-attempt', attempt);
    } catch (error) { return; }
    select.value = target;
    form.elements.language_code.value = config.language;
    params.set('country', target);
    form.elements.return_to.value = location.pathname + '?' + params.toString() + location.hash;
    HTMLFormElement.prototype.submit.call(form);
  }
  start();
})();
